import el from 'date-fns/locale/el';

const DateTimeFormats = {
  sunday: 'Κυ',
  monday: 'Δε',
  tuesday: 'Τρ',
  wednesday: 'Τε',
  thursday: 'Πε',
  friday: 'Πα',
  saturday: 'Σα',
  ok: 'OK',
  today: 'Σήμερα',
  yesterday: 'Χθες',
  now: 'Τώρα',
  hours: 'Ώρες',
  minutes: 'Λεπτά',
  seconds: 'Δευτερόλεπτα',
  /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  shortDateFormat: 'dd/MM/yyyy',
  shortTimeFormat: 'HH:mm',
  dateLocale: el as any,
};

const Combobox = {
  noResultsText: 'Δεν βρέθηκαν αποτελέσματα',
  placeholder: 'Επιλογή',
  searchPlaceholder: 'Αναζήτηση',
  checkAll: 'Όλα',
};

const CreatableComboBox = {
  ...Combobox,
  newItem: 'Νέο αντικείμενο',
  createOption: 'Δημιουργία επιλογής "{0}"',
};

export default {
  code: 'el-GR',
  common: {
    loading: 'Φόρτωση...',
    emptyMessage: 'Δεν βρέθηκαν δεδομένα',
    remove: 'Αφαίρεση',
    clear: 'Καθαρισμός',
  },
  Plaintext: {
    unfilled: 'Ανεκπλήρωτος',
    notSelected: 'Μη επιλεγμένο',
    notUploaded: 'Μη φορτωμένο',
  },
  Pagination: {
    more: 'Περισσότερα',
    prev: 'Προηγούμενο',
    next: 'Επόμενο',
    first: 'Πρώτο',
    last: 'Τελευταίο',
    limit: '{0} / σελίδα',
    total: 'Σύνολο γραμμών: {0}',
    skip: 'Μετάβαση στο {0}',
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: 'Τελευταίες 7 ημέρες',
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: 'Αρχικοποίηση',
    progress: 'Μεταφόρτωση',
    error: 'Σφάλμα',
    complete: 'Ολοκληρώθηκε',
    emptyFile: 'Άδειο',
    upload: 'Μεταφόρτωση',
    removeFile: 'Αφαίρεση αρχείου',
  },
  CloseButton: {
    closeLabel: 'Κλείσιμο',
  },
  Breadcrumb: {
    expandText: 'Εμφάνιση διαδρομής',
  },
  Toggle: {
    on: 'Ανοιχτό',
    off: 'Κλειστό',
  },
};
